<template>
  <div>
    <page-title
      :title="$t('components.main.navigation.partner.with.us.airalo-for-corporates')"
      :back-button="{ url: breadcrumbs[0].link, hiddenAfterSizes: 'sm' }"
      :bordered="true"
    />
    <div class="airalo-for-corporates-page my-20 my-md-30 my-lg-40 px-20 px-sm-30">
      <breadcrumb :breadcrumbs="breadcrumbs" />
      <partner-with-us-contents :contents="contents" />
      <airalo-affiliate-partners-have-to-say join-us-type="corporate" />
      <looking-for-more-custom />
    </div>
  </div>
</template>

<script>
  import Breadcrumb from '~/components/partner-with-us/breadcrumb'
  import PartnerWithUsContents from '~/components/partner-with-us/contents.vue'
  import LookingForMoreCustom from '~/components/partner-with-us/airalo-partner-hub/looking-for-more-custom'
  import AiraloAffiliatePartnersHaveToSay from '~/components/partner-with-us/airalo-affiliate-partners-have-to-say'
  import PageTitle from '~/components/shared/page-title.vue'
  import partnerPageMixin from '~/mixins/partner-pages'

  export default {
    name: 'airalo-for-corporates',

    components: {
      PageTitle,
      Breadcrumb,
      LookingForMoreCustom,
      PartnerWithUsContents,
      AiraloAffiliatePartnersHaveToSay,
    },

    mixins: [
      partnerPageMixin(
        'components.main.navigation.partner.with.us.airalo-for-corporates',
        'airalo-for-corporates',
        'airalo-for-corporates'
      ),
    ],

    head() {
      return {
        title: this.$te('seo.partner.with.us.airalo-for-corporates-title')
          ? this.$t('seo.partner.with.us.airalo-for-corporates-title')
          : this.$t('seo.homepage.title'),
        meta: [
          {
            hid: 'description',
            name: 'description',
            content: this.$t('seo.partner.with.us.airalo-for-corporates-description'),
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: this.$t('seo.partner.with.us.airalo-for-corporates-keywords'),
          },
          {
            property: 'og:title',
            content: this.$t('seo.partner.with.us.airalo-for-corporates-title'),
          },
          {
            property: 'og:description',
            content: this.$t('seo.partner.with.us.airalo-for-corporates-description'),
          },
        ],
      }
    },
  }
</script>
